export function cost(sum: number): string {
  return Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    maximumFractionDigits: 0,
  }).format(sum);
}

export function number(value: number): string {
  return Intl.NumberFormat('sv-SE', {}).format(value);
}

export function percent(value: number): string {
  return `${Intl.NumberFormat('sv-SE', {
    maximumFractionDigits: 20,
  }).format(value)} %`;
}
